<template>
  <v-container fluid :class="contactContainerClass">
    <v-slide-y-transition mode="out-in">
        <router-view/>
    </v-slide-y-transition>
    <ModalContainer :modalKey="'addGroup'" :width="'562'">
      <AddGroup
        @done="onAddGroupDone"
        @cancelled="onaddGroupCancelled"
      />
    </ModalContainer>
    <!-- <template
      v-if="addGroupModalContainer"
    >
      <v-dialog 
        v-model="addGroupModal"
        persistent
        width="562"
      >
        <AddGroup
          @done="onAddGroupDone"
          @cancelled="onaddGroupCancelled"
         />
      </v-dialog>
    </template> -->

    <template
      v-if="addContactModalContainer"
    >
      <v-dialog 
        v-model="addContactModal"
        persistent
        width="390"
      >
        <AddContact
          @cancelled="onaddContactCancelled"
          @new_contact="onNewContactAdded"
         />
      </v-dialog>
    </template>

    <template
      v-if="contactsGroupsAddNewModalContainer"
    >
      <v-dialog 
        v-model="contactsGroupsAddNewModal"
        persistent
        width="390"
      >
        <!-- <GroupModal @cancelled="onaddGroupCancelled"/> -->
        <ContactsGroupsAddNew
          @cancelled="onaddGroupCancelled"
         />
      </v-dialog>
    </template> 

    <template
      v-if="contactsImportExportMergeContactsModalContainer"
    >      
      <v-dialog 
        v-model="contactsImportExportMergeContactsModal"
        persistent
        width="562"
      >
        <ContactsImportExportMerge
          @cancelled="onMergeContactsCancelled"
         />
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import { ContactStoreNamespace as storeNS } from './store';
import * as ActionTypes from './store/types';

import {childOfOrEqualDetails, contactListLDTRoutes} from './router/routes';
import { createModalMixin } from '../../dt-plugins/modal/modal.mixin';

import AddGroup from '@/dt-plugins/groups/add-group';
import AddContact from '../../dt-plugins/add-contact-relation/add-contact';
import ContactsGroupsAddNew from './components/groups/contacts-groups-add-modal';
import ContactsImportExportMerge from './components/import-export/merge-contact-modal';
import CompareModal from './components/import-export/merge-contact-compare-modal';
import { ContactService } from '../../dt-plugins/add-contact-relation/contact.service';
import { mapKeyToAction } from '../../store/global';
import ModalContainer from '../../dt-plugins/modal/modal-container';
import GroupModal from './components/groups/contacts-groups-add-modal'
export default {
  components: {
    ModalContainer,
    AddGroup,
    AddContact,
    ContactsGroupsAddNew,
    ContactsImportExportMerge,
    CompareModal,
    GroupModal
  },
  data: function () {
    return {
    };
  },
  mixins: [
    createModalMixin('addGroup'),
    createModalMixin('addContact'),
    createModalMixin('contactsGroupsAddNew'),
    createModalMixin('contactsImportExportMergeContacts'),
   
    createModalMixin('GroupModal')

  ],
  computed: {
    contactContainerClass: function() {
      return {
        'dt-module': true,
        'inactive': childOfOrEqualDetails(this.$route)
      };
    }
  },
  methods: {
    ...mapKeyToAction(storeNS, [
      ActionTypes.ContactsData.FETCH.ALL
    ]),
    onaddGroupCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          contact_id: undefined
        }
      });
    },
    onMergeContactsCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined
        }
      });
    },
    onAddGroupDone: function({action, payload}) {
      this.onaddGroupCancelled();
      this.$store.dispatch(action, payload);
    },
    onaddContactCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined
        }
      });
    },
    onNewContactAdded: async function(payload) {
      console.log(payload);
      const { type, contact } = payload;
      let insertedContact;
      if (type === 'person') {
        insertedContact = await ContactService.insertPerson(contact);
      } else if (type === 'company') {
        insertedContact = await ContactService.insertCompany(contact);
      }
      this.onaddContactCancelled();
      this[ActionTypes.ContactsData.FETCH.ALL]({
        startRow: 0
      });

      const contact_id = insertedContact.data.contact_id;

      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: contact_id,
          tab: 'overview'
        }
      });
    },
    // MARK: Methods
  }
}
</script>

